import React from 'react';
import { ReactNode } from 'react';

type IMainProps = {
  meta: ReactNode;
  slider?: boolean;
  children: ReactNode;
};

const StocksLayout = (props: IMainProps): JSX.Element => (
  <>
    <div className="antialiased w-full text-gray-700 sm:flex-col ">
      {props.meta}
      <div className="sm:w-full sm:mx-0 sm:p-0  ">{props.children}</div>
    </div>
  </>
);

export { StocksLayout };
